/**
 * @fileoverview Action type constants for phases.
 */
export const ADD_PHASE = "phases/ADD_PHASE";
export const EDIT_PHASE = "phases/EDIT_PHASE";
export const REMOVE_PHASE = "phases/REMOVE_PHASE";
export const TOGGLE_PHASE_VISIBILITY = "phases/TOGGLE_PHASE_VISIBILITY";
export const MOVE_PHASE_UP = "phases/MOVE_PHASE_UP";
export const MOVE_PHASE_DOWN = "phases/MOVE_PHASE_DOWN";
export const LOAD_STATE = "LOAD_STATE";
